import Vue from 'vue'
import VueI18n from 'vue-i18n'
import storage from 'store'
import moment from 'moment'

import enUS from './lang/en-US'
import zhCN from './lang/zh-CN'

Vue.use(VueI18n)

// 默认语言
export const defaultLang = 'en-US'
// 获取浏览器语言标识
// const navLang = navigator.language || navigator.userLanguage
// console.log('navigator.language', navigator.language)
// console.log('navigator.userLanguage', navigator.userLanguage)
// const lang = navLang || defaultLang // 实际语言包
// console.log('navLang', navLang)
// $store.commit('APP_LANGUAGE', defaultLang)

console.log()
const lang = defaultLang
console.log('process.env.NODE_ENV', process.env.NODE_ENV === 'dev')

console.log('lang', lang)
const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: process.env.NODE_ENV === 'dev' ? defaultLang : lang,
  fallbackLocale: defaultLang,
  messages: {
    'en-US': {
      ...enUS
    },
    'zh-CN': {
      ...zhCN
    }
  }
})

const loadedLanguages = [defaultLang]

function setI18nLanguage (lang) {
  i18n.locale = lang
  // request.headers['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang = defaultLang) {
  return new Promise(resolve => {
    if (window.ipcRenderer) {
      window.ipcRenderer.send('switchLang', lang)
      // window.ipcRenderer.send('toMain', 'getPlatform')
    }
    // 缓存语言设置
    storage.set('lang', lang)
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
          const locale = msg.default
          i18n.setLocaleMessage(lang, locale)
          loadedLanguages.push(lang)
          moment.updateLocale(locale.momentName, locale.momentLocale)
          return setI18nLanguage(lang)
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}

export function i18nRender (key) {
  return i18n.t(`${key}`)
}

export default i18n
